/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */
import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const StyledLogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),

  '& img': {
    width: '32px',
    height: '32px',
  },

  '& p': {
    fontSize: '18px',
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
    color: theme.palette.text.primary,
    textDecoration: 'none',

    '& span': {
      fontWeight: theme.typography.fontWeightMedium,
    },
  },

  '&:hover': {
    cursor: 'pointer',
  },
}));

function Logo() {
  return (
    <StyledLogoContainer>
      <img src="/icons/stars.svg" alt="logo" />
      <p>
        Zlayt<span>AI</span>
      </p>
    </StyledLogoContainer>
  );
}

export default Logo;
